import { render } from "./App.vue?vue&type=template&id=4851ae6c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4851ae6c&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__